/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Createeventmanually2Inputs */

const en_createeventmanually2 = /** @type {(inputs: Createeventmanually2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manually`)
};

const de_createeventmanually2 = /** @type {(inputs: Createeventmanually2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuell`)
};

/**
* | output |
* | --- |
* | "Manually" |
*
* @param {Createeventmanually2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const createeventmanually2 = /** @type {((inputs?: Createeventmanually2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Createeventmanually2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_createeventmanually2(inputs)
	return de_createeventmanually2(inputs)
});
export { createeventmanually2 as "createEventManually" }